export default __webpack_public_path__ + "static/media/Sheet.7f344e52.svg";